module.exports = __webpack_public_path__ + "img/yesica-wild-byn.5a56951c.jpg";